<template>
  <section :class="style.sectionHeaderBlock">
    <div :class="style.header">
      <h1>{{ title }}</h1>
      <div :class="style.buttons">
        <slot name="buttons" />
      </div>
    </div>
    <p v-if="conditionSubTitle && subTitle">
      {{ subTitle }}
    </p>
  </section>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "./SectionHeaderBlock.module.scss";

export default defineComponent({
  name: "SectionHeaderBlock",
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    conditionSubTitle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      style
    };
  }
});
</script>
